export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-map-7e3e07cae60769341035fa8c1e458fa8.svg";